import { UserAvatarComponent } from '@app/shared/components/user-avatar/user-avatar.component';
/* eslint-disable no-shadow */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { selectItems } from '@app/root-store/relationship-store/relationship.selector';
import { UserConnectionService } from '@app/shared/services/user_connection/user-connection.service';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
@AutoUnsubscribe()
@Component({
    selector: 'mutual-connection',
    templateUrl: './mutual-connection.component.html',
    styleUrl: './mutual-connection.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      UserAvatarComponent,
      MatIconModule,
      MatButtonModule
    ]
})
export class MutualConnectionComponent implements OnInit, OnDestroy {
  private _dialogRef = inject(MatDialogRef<MutualConnectionComponent>);
  public data = inject(MAT_DIALOG_DATA);
  private UserConnection = inject(UserConnectionService);
  private cdr = inject(ChangeDetectorRef);
  private store = inject(Store);

  mutualUserlist: any[] | null = null;
  subscription = new Subscription();
  myRelationship$: Observable<any[]>;
  myRelationship: any = [];

  constructor() {
    this.myRelationship$ = this.store.select(selectItems);
    this.subscription.add(
      this.myRelationship$.subscribe((data) => {
        this.myRelationship = data;
      })
    );
  }

  ngOnInit(): void {
    const user_id = this.data.id;
    this.subscription.add(
      this.UserConnection.getMutualConnections(user_id).subscribe((data) => {
        data.forEach((user: any) => {
          const matchedRelationship = this.myRelationship.find((rel: any) => rel.user_id === user.id);
          user.relationship_name = matchedRelationship ? matchedRelationship.relationship_name : null;
        });
        this.mutualUserlist = data;
        this.cdr.markForCheck(); // Trigger change detection
      })
    );
  }

  getMutualConnection() {
    const user_id = this.data.id;
    this.subscription.add(
      this.UserConnection.getMutualConnections(user_id).subscribe((data) => {
        data.forEach((user: any) => {
          const matchedRelationship = this.myRelationship.find((rel: any) => rel.user_id === user.id);
          user.relationship_name = matchedRelationship ? matchedRelationship.relationship_name : null;
        });
        this.mutualUserlist = data;
        this.cdr.markForCheck(); // Trigger change detection
      })
    );
  }

  closeDialog(): void {
    this._dialogRef.close();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
